import React, { useEffect, useState } from "react";
import DataTableBase from "../../../Components/Common/DataTableBase/DataTableBase";
import { t } from "i18next";
import { useSiteStore } from "../../../stores/Assets/site";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  UncontrolledTooltip,
} from "reactstrap";
import { AddSite } from "./Components/AddSite";
import { EditSite } from "./Components/EditSite";
import { useLocation } from "react-router-dom";
import { useConfirmDialogStore } from "../../../stores/Modal/ConfirmDialogStore";
import { Permission } from "../../../Layouts/Permissions";
import { canEdit } from "../../../helpers/permissions";
import SearchBar from "../../../Components/Common/SearchBar";
import { useUsageStore } from "../../../stores";
import { PlanUpgradeModal } from "../../../Components/Common/PlanUpgradeModal";

const Sites = () => {
  const [totalRows, setTotalRows] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  document.title = "Clickorder Admin";
  const location = useLocation();
  const siteId = new URLSearchParams(location.search).get("siteId");
  const { getSiteList, pagination, isLoading, siteList, deleteSite } =
    useSiteStore((state) => state);

  useEffect(() => {
    if (siteId) {
      setSearchTerm(siteId);
      setCurrentPage(1);
    }
  }, [siteId]);

  useEffect(() => {
    getSiteList(1, rowsPerPage, searchTerm);
    setCurrentPage(1);
    useUsageStore.getState().fetchUsage();
  }, [searchTerm]);

  useEffect(() => {
    setTotalRows(pagination?.totalItems || 0);
  }, [pagination]);
  const columns = [
    {
      name: t("ID"),
      width: "80px",
      selector: (row) => row?.site_id,
      sortable: true,
      wrap: true,
    },

    {
      name: t("LOGO"),
      // width: "100px",
      selector: (row) => row.image_url,
      sortable: true,
      wrap: true,
      cell: (row) => (
        <img
          src={row.image_url}
          style={{ borderRadius: "100%" }}
          width={28}
          alt=""
        />
      ),
    },

    {
      name: t("Name"),
      // width: "100px",
      selector: (row) => row?.name,
      sortable: true,
      wrap: true,
      cell: (row) => (
        <div className="d-flex flex-row justify-content-center align-items-center gap-2">
          <span>{row?.name}</span>
        </div>
      ),
    },

    {
      name: t("Name (AR)"),
      // width: "100px", //row?.name
      selector: (row) => row?.name_ar,
      sortable: true,
      wrap: true,
      cell: (row) => (
        <div className="d-flex flex-row justify-content-center align-items-center gap-2">
          <span>{row?.name_ar}</span>
        </div>
      ),
    },
    {
      name: t("City"),
      // width: "100px",
      selector: (row) => row?.address,
      sortable: true,
      wrap: true,
    },
    {
      name: t("City (AR)"),
      // width: "100px",
      selector: (row) => row?.address_ar,
      sortable: true,
      wrap: true,
    },
    {
      name: t("Phone"),
      // width: "100px",
      selector: (row) => row?.phone,
      sortable: true,
      wrap: true,
    },
    {
      name: t("GPS"),
      // width: "190px",
      selector: (row) => row?.lat,
      sortable: true,
      wrap: true,
      // format: (row) =>
      //   `lat: ${row?.location?.coordinates[0]} lng: ${row?.location?.lon}`,
      cell: (row) => (
        <a
          href={`https://www.google.com/maps/search/?api=1&query=${row?.latitude?.toFixed(
            6
          )},${row?.longitude?.toFixed(6)}`}
          target="_blank"
          className="link-style"
          rel="noopener noreferrer"
        >
          <strong>
            {row?.latitude?.toFixed(6)}, {row?.longitude?.toFixed(6)}
          </strong>
        </a>
        //  <span>
        //     {row?.location?.lat?.toFixed(6)},
        //     {row?.location?.lon?.toFixed(6)}
        //   </span>
      ),
    },
    // {
    //   name: t("Kitchens"),
    //   // width: "95px",
    //   // selector: (row) => row?.status,
    //   sortable: true,
    //   wrap: true,
    //   cell: (row) => (
    //     <div className="cursor-normal" id={`anchor-${row?.code}`}>
    //       <span
    //         style={{ fontSize: "14px" }}
    //         className={`badge bg-soft-info  cursor-pointer text-success text-uppercase`}
    //       >
    //         <i className="ri-external-link-line"></i>{" "}
    //       </span>
    //       <UncontrolledTooltip placement="top" target={`anchor-${row?.code}`}>
    //         {" "}
    //         check Associated Kitchens
    //       </UncontrolledTooltip>
    //     </div>
    //   ),
    // },
    {
      name: t("Spaces"),
      // width: "95px",
      // selector: (row) => row?.status,
      sortable: true,
      wrap: true,
      cell: (row) => (
        <a
          href={`/spaces?siteId=${row?.site_id}`}
          className="cursor-normal"
          id={`anchor-${row?.site_id}`}
        >
          <span
            style={{ fontSize: "14px" }}
            className={`badge bg-soft-info cursor-pointer text-success text-uppercase`}
          >
            <i className="ri-external-link-line"></i>
          </span>
          <UncontrolledTooltip
            placement="top"
            target={`anchor-${row?.site_id}`}
          >
            {" "}
            check Associated Spaces
          </UncontrolledTooltip>
        </a>
      ),
    },
  ];

  const searchHandler = (searchText) => {
    setSearchTerm(searchText);
    setCurrentPage(1); // Reset to first page on search
  };
  const { showConfirm } = useConfirmDialogStore((state) => state);

  const [showAddSiteModal, setShowAddSiteModal] = useState(false);
  const [showEditSiteModal, setShowEditSiteModal] = useState(false);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  const { getLimitInfo } = useUsageStore();
  const siteLimit = getLimitInfo("sites");
  const isLimitReached = siteLimit?.isReached;

  const toggleAddSiteModal = () => {
    if (!showAddSiteModal && isLimitReached) {
      setShowUpgradeModal(true);
      return;
    }
    setShowAddSiteModal(!showAddSiteModal);
  };

  const toggleUpgradeModal = () => {
    setShowUpgradeModal(!showUpgradeModal);
  };

  const [selectedRow, setSelectedRow] = useState(null);
  const toggleEditSiteModal = (row) => {
    setSelectedRow(row);
    setShowEditSiteModal(!showEditSiteModal);
  };

  const onChangePage = (page) => {
    getSiteList(page, rowsPerPage, searchTerm);
    setCurrentPage(page);
  };

  const deleteSiteFun = async (id) => {
    try {
      await deleteSite(id);
    } catch (e) {
      console.log(e);
    }
  };

  const [canEditSite, setCanEditSite] = useState(false);

  useEffect(() => {
    const checkPermission = async () => {
      const res = await canEdit("site");
      setCanEditSite(res);
    };

    checkPermission();
  }, []);

  return (
    <>
      <DataTableBase
        tableTitle={"BRANCHES"}
        customHeader={
          <div className="w-100">

            <div className="d-flex flex-column flex-md-row align-items-stretch justify-content-between gap-2 w-100 mb-2">
              {/**should show only if the user has the permission to add a site  */}
              {canEditSite && (
                <div className="position-relative" style={{ flex: "0 0 10%" }}>
                  <Button
                    color={isLimitReached ? "secondary" : "success"}
                    onClick={toggleAddSiteModal}
                    className="d-flex align-items-center justify-content-center w-100"
                    style={{
                      padding: "0.4rem 2rem",
                      whiteSpace: "nowrap",
                      fontSize: "13px",
                      opacity: isLimitReached ? 0.7 : 1,
                    }}
                    id="add-site-btn"
                  >
                    + {t("Add Site")}
                  </Button>
                  {isLimitReached && (
                    <UncontrolledTooltip target="add-site-btn">
                      {t("Limit reached. Upgrade to add more.")}
                    </UncontrolledTooltip>
                  )}
                </div>
              )}
              <div
                className="d-flex align-items-center gap-2 w-100"
                style={{ flex: "0 0 40%" }}
              >
                <h6 className="text-nowrap mb-0">Search: </h6>
                <div className="flex-grow-1">
                  <SearchBar
                    submitMode
                    onSearch={searchHandler}
                    placeholder="Search branches by name or id..."
                  />
                </div>
              </div>
            </div>
          </div>
        }
        data={siteList || []}
        columns={columns}
        loading={isLoading}
        paginationTotalRows={totalRows}
        onChangePage={onChangePage}
        // onChangeRowsPerPage={onChangeRowsPerPage}
        onHeaderAddBtnClick={null}

        // onHeaderDeleteBtnClick={() => {
        //   alert("Soon");
        // }}
        onSearchIconClick={searchHandler}
        actionColWidth="100px"
        showSearch={false}

        showActionColumn={canEditSite}
        showSubHeader={false}
        showActionButtons={false}
        customActionBtns={(row) => (
          <>
            <Permission level={2} feature="site">
              <button
                className="btn btn-sm btn-warning"
                onClick={() => {
                  toggleEditSiteModal(row);
                }}
                title="Edit"
              >
                <i className="ri-edit-fill"></i>{" "}
              </button>
            </Permission>
            <Permission level={2} feature="site">
              <button
                className="btn btn-sm btn-danger"
                onClick={() => {
                  showConfirm(
                    () => {
                      deleteSiteFun(row.site_id);
                    },
                    () => {
                      console.log("Cancelled");
                    },
                    "Confirmation", // Title of the confirmation dialog
                    `Are you sure you want to delete site ${row?.name} (id: ${row?.site_id})?` // Question displayed in the dialog
                  );
                }}
                title="Delete"
              >
                <i className="ri-delete-bin-line"></i>
              </button>
            </Permission>
          </>
        )}
      />

      <AddSite
        toggleAddSiteModal={toggleAddSiteModal}
        showAddSiteModal={showAddSiteModal}
      />
      <PlanUpgradeModal
        isOpen={showUpgradeModal}
        toggle={toggleUpgradeModal}
      />
      {selectedRow && (
        <EditSite
          toggleEditSiteModal={toggleEditSiteModal}
          showEditSiteModal={showEditSiteModal}
          rowData={selectedRow}
        />
      )}
    </>
  );
};

export default Sites;
